import request from "@/services/request";
import baseUrl from "@/services/baseUrl";

// this is for globally used APIs only
const payLinkUrl = baseUrl.main + "/tz988/v1/payment-link/";
// const payLinkUrl = "http://localhost:3020/v1/payment-link/";
const url = baseUrl.notSandbox + '/ba021/v1/org/';
const accountUrl = baseUrl.main + '/fapi/v1/mch-account/';
const userUrl = baseUrl.main + '/fapi/v1/user/';
const merchantUrl = baseUrl.main + '/fapi/merchant/';
const fapiUrl = baseUrl.main + '/fapi/';
const customersUrl = baseUrl.main + '/fapi/v1/customer/';
const settlementUrl = baseUrl.main + '/fapi/v1/mch-settlement/';
const autoSettlementUrl = baseUrl.main + '/fapi/auto-settlement/';
const directChargeUrl = baseUrl.main + '/fapi/request/';
const transfer = baseUrl.main + "/fapi/transfer/";
const xpay = baseUrl.main + "/fapi/v1/xpay/";

const returnUrl = `${location.origin}/transactions/details`;




export const directCharge = {
    createDirectCharge: (param = {}) => request.post(directChargeUrl +"create-mobile-wallet-charge", param),
    refreshStatus: (param = {}) => request.post(directChargeUrl +"refresh-transaction-status", {_id:param}),
    cancel: (param = '') => request.post(directChargeUrl +"cancel", {_id: param}),
    approve: (param = {}) => request.post(directChargeUrl + "approve", param),
    reject: (param = {}) => request.post(directChargeUrl + "reject", param),
    list: (param = '') => request.get(directChargeUrl + "list?" + param, {}),
    view: (param = '',hideLoadingSpinner = false) => request.get(directChargeUrl + `view?_id=${param}`,{hideLoadingSpinner: true},),
    automaticRefunds: (param = '') => request.get(fapiUrl + "refund/list?" + param, {}),
    getMotives: (param = '') => request.get(baseUrl.main + "/fapi/v1/refund/list-request-reason-codes", {}),
    transaction: (param = '') => request.get(directChargeUrl + "list-transactions?" + param, {}),
}

export const accounts = {
    createManualSettlement: (param = {}) => request.post(transfer + "withdraw", {...param, returnUrl}),
    paymentMethods: (params = '') => request.get(baseUrl.main + '/fapi/payment-method/list-for-settlement?', {}),
    betweenAccounts: (param= {}) => request.post(transfer + "transfer-between-accounts", {...param, returnUrl}),
    create: (param = {}) => request.post(accountUrl + "create", param),
    update: (param = {}) => request.post(accountUrl + "update", param),
    list: (param = '') => request.get(accountUrl + "list?" + param, {}),
    view: (param = '') => request.get(accountUrl + "view?_id=" + param, {}),
}

export default {
    // getUserById: (params = {}) => request.post(baseUrl.main + "/ba021/v1/admin/userById", params),
    // getMembers: (params = {}) => request.post(url + "list", params),
    // addMember: (params = {}) => request.post(url + "new", params),
    // updateMember: (params = {}) => request.put(url + "user", params),
    // removeMember: (params = null) => request.post(url + "delete/" + params, {}),

    getUserById: (params = {}) => request.post(url + "admin/userById", params),
    getUserByPhone: (params = {}) => request.post(url + "get-or-create-by-phone", params),
    enableDisableUser: (params = {}) => request.post(url + "enable-disable", params),
    getMembers: (params = {}) => request.post(url + "list", params),
    manageUserNotificationAccess: (params = {}) => request.post(url + "toggle-notification-permission", params),
    addMember: (params = {}) => request.post(baseUrl.notSandbox + "/ba021/v1/org/new", params),
    // addMember: (params = {}) => request.post("http://localhost:3006/ba021/v1/org/new", params), 
    updateMember: (params = {}) => request.put(url + "user", params),
    removeMember: (params = null) => request.post(url + "delete/" + params, {}),
    orgDetail: (params = '') => request.get(baseUrl.notSandbox + "/ba021/v1/business-account/orgAccount/" + params),
}